import type { ReactNode } from 'react';

export const symbol_deployed_code_history: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-823 213-669l267 155 266-155-266-154ZM120-310v-340q0-16 7.88-29.79Q135.75-693.57 150-702l300-173q8-5 14.95-6.5 6.95-1.5 15-1.5t15.55 1.5Q503-880 510-875l300 173q14.25 8.43 22.13 22.21Q840-666 840-650v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-150L511-463q-14 8-30 8.5t-30-7.5L180-619v309l285 164q6.75 3.82 10.88 10.71Q480-128.41 480-120q0 17-15 25.5t-30 .5L150-258q-14.25-8.43-22.12-22.21Q120-294 120-310ZM596-55.4q-56-55.4-56-134T596-324q56-56 134-56t134 55.87q56 55.86 56 135.13 0 78.43-56 133.72Q808 0 730 0T596-55.4ZM480-478Zm271 284v-103.04q0-8.96-6-14.96t-15-6q-9 0-15 6t-6 14.97V-195q0 6.07 2.5 11.76 2.5 5.69 7.5 10.24l76 70q5 5 13 4.5t13-5.5q6-6 5.5-14t-6.5-13l-69-63Z"
		/>
	</svg>
);
